"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapPluginFromArrayDeclaration = exports.ensureConfigFileExists = exports.getConfig = exports.getConfigFileLocation = exports.executeConfigFile = void 0;
var fileSaveUtilities_1 = require("./fileSaveUtilities");
var path = require("path");
var fs = require("fs");
var constants_1 = require("./constants");
exports.executeConfigFile = function (database) {
    var _a;
    var config = exports.getConfig();
    (_a = config.plugins) === null || _a === void 0 ? void 0 : _a.forEach(function (pluginDeclaration, index) {
        var _a = __read(exports.unwrapPluginFromArrayDeclaration(pluginDeclaration), 2), plugin = _a[0], config = _a[1];
        switch (typeof plugin) {
            case 'function': {
                return plugin(database, config);
            }
            case 'string': {
                var pluginRequireId = plugin;
                if (plugin.startsWith('./') || plugin.startsWith('../')) {
                    pluginRequireId = path.resolve(fileSaveUtilities_1.getTargetDir(), plugin);
                }
                var requiredPlugin = require(pluginRequireId);
                if (typeof requiredPlugin === 'function') {
                    return requiredPlugin(database, config);
                }
                return requiredPlugin.default(database, config);
            }
            default:
                console.log("An incorrect plugin syntax was passed in your config.");
                console.log("Path: sextantConfig.plugins[" + index + "]");
                console.log("Plugin passed: " + JSON.stringify(plugin));
        }
    });
};
exports.getConfigFileLocation = function () {
    var targetDir = fileSaveUtilities_1.getTargetDir();
    var configFileLocation = undefined;
    for (var filename in constants_1.PERMITTED_SEXTANT_CONFIG_FILENAMES) {
        var location_1 = path.resolve(targetDir, filename);
        if (fs.existsSync(location_1)) {
            configFileLocation = location_1;
            break;
        }
    }
    return (configFileLocation ||
        path.resolve(targetDir, constants_1.PERMITTED_SEXTANT_CONFIG_FILENAMES[0]));
};
exports.getConfig = function () {
    var configFileLocation = exports.getConfigFileLocation();
    if (!configFileLocation) {
        return {};
    }
    return require(configFileLocation);
};
exports.ensureConfigFileExists = function () {
    var configFileLocation = exports.getConfigFileLocation();
    if (!fs.existsSync(configFileLocation)) {
        fs.writeFileSync(configFileLocation, constants_1.DEFAULT_CONFIG_FILE);
    }
};
exports.unwrapPluginFromArrayDeclaration = function (pluginDeclaration) {
    if (Array.isArray(pluginDeclaration)) {
        return [pluginDeclaration[0], pluginDeclaration[1] || {}];
    }
    return [pluginDeclaration, {}];
};
